import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { toErrorText } from "@/components/snapshot/snapshot.utils";
import { useSnapshotSection } from "@/components/snapshot/snapshotSection.context";

/** Shown in place of a section's file list while the day's S3 list loads, fails or is empty. */
export const SnapshotDropzoneExistingState = () => {
  const section = useSnapshotSection();
  const existing = section.existing;
  const hasUploading = section.files.length > 0;

  let content = null;
  if (existing.isLoading) {
    content = <Skeleton variant="text" />;
  }
  else if (existing.error) {
    content = (
      <Typography
        color="error"
        variant="body2"
      >
        Couldn't list the files in S3: {toErrorText(existing.error)}
      </Typography>
    );
  }
  else if (existing.files.length === 0 && !hasUploading) {
    content = (
      <Typography
        color="text.secondary"
        variant="body2"
      >
        No {section.label} files for {section.dateLabel} yet. Add the day's exports above, then build the snapshot.
      </Typography>
    );
  }
  if (!content) return null;

  return (
    <Box
      sx={{
        pb: 1.5,
        pt: 0.5,
      }}
    >
      {content}
    </Box>
  );
};
